<template>
  <ApplyLayout>
    <ApplyForm v-on:form-submitted="submitData" />
    <PageLoading v-if="loading" />
  </ApplyLayout>
</template>

<script>
import ApplyForm from "@/components/Forms/ApplyForm.vue";
import ApplyLayout from "@/Layout/NotAuthenticated/ApplyLayout.vue";

export default {
  name: "Apply",
  components: {
    ApplyForm,
    ApplyLayout,
  },
  data() {
    return {
      loading: false,
      user: null,
    };
  },
  methods: {
    async submitData(user) {
      this.user = user;
      this.loading = true;
      try {
        await this.$store.commit("UPDATE_USER", this.user);
        await this.$store.dispatch("createUser", this.$store.state.user);
        const user = {
          username: this.$store.state.user.email,
          password: this.$store.state.user.password,
        };
        await this.$store.dispatch("logUserIn", user);
        await this.$store.dispatch("getUser");
        this.loading = false;
        this.$router.push("/");
      } catch (error) {
        this.loading = false;
        this.$toasted.global.notificate({
          message: error.response.data.errors[0].description,
          type: "error",
        });
      }
    },
  },
};
</script>
